import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Tinode } from "../tinode/tinode";

class SearchOptions extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div id="search-option">
        <div className="selection">
          <div
            className={`option ${this.props.optionSearch === Tinode.OPTIONS_SEARCH.MESSAGE && 'active'}`}
            onClick={() => this.props.handleSetOptionSearch(Tinode.OPTIONS_SEARCH.MESSAGE)}>
            <FormattedMessage
              id="search_option_message"
              defaultMessage="Messages"
              description="Search option messages"
            />
          </div>
          <div
            className={`option ${this.props.optionSearch === Tinode.OPTIONS_SEARCH.CONTACT && 'active'}`}
            onClick={() => this.props.handleSetOptionSearch(Tinode.OPTIONS_SEARCH.CONTACT)}>
            <FormattedMessage
              id="search_option_contact"
              defaultMessage="Contact"
              description="Search option contact"
            />
          </div>
          <div
            className={`option ${this.props.optionSearch === Tinode.OPTIONS_SEARCH.GROUP && 'active'}`}
            onClick={() => this.props.handleSetOptionSearch(Tinode.OPTIONS_SEARCH.GROUP)}>
            <FormattedMessage
              id="search_option_group"
              defaultMessage="Group"
              description="Search option group"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(SearchOptions);
